const contentRows = [
  {
    date: "February 29, 1960",
    content:
      "Anthony Jay Robbins (born Anthony J. Mahavoric; February 29, 1960) is an American author, coach, speaker, and philanthropist. Robbins is known for his infomercials, seminars, and self-help books including the books Unlimited Power (published in 1987) and Awaken the Giant Within (published in 1993). His seminars are organized through Robbins Research International.",
    contentStyles: { top: 0, width: "30em" },
    images: [
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-4.jpg").default,
        imageStyles: { width: "32em", height: "18em" },
      },
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-6.jpeg").default,
        imageStyles: { width: "25em", height: "30em" },
      },
    ],
  },
  {
    date: "1980",
    content: `Robbins started his career by promoting Jim Rohn’s motivational seminars. Jim Rohn was a motivational author and speaker as well as an entrepreneur.
Jim Rohn explained to him that happiness and success depends on what one does with the available resources in his or her life. Robbins was inspired by Jim and began life coaching.`,
    contentStyles: { top: 0, width: "30em" },
    images: [
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-4.jpg").default,
        imageStyles: { width: "32em", height: "18em" },
      },
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-6.jpeg").default,
        imageStyles: { width: "25em", height: "30em" },
      },
    ],
  },
  {
    date: "1985",
    content: `In November 2019, BuzzFeed News published a six-part article accusing Robbins of molesting a teenage girl during his time as a "star speaker" at SuperCamp, an elite summer camp in southern California. The article claims the events took place in 1985 when Robbins was 25, and that there were at least two eyewitnesses. Other media outlets also reported on these allegations. Robbins denied wrongdoing and started to sue BuzzFeed News in Ireland. In response, BuzzFeed News said that they stand by their reporting and suggested that Robbins' decision to file the summons in Ireland was an "abuse" of the Irish court.`,
    contentStyles: { top: 0, width: "30em" },
    images: [
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-4.jpg").default,
        imageStyles: { width: "32em", height: "18em" },
      },
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-6.jpeg").default,
        imageStyles: { width: "25em", height: "30em" },
      },
    ],
  },
  {
    date: "1991",
    content: `In 1991, Robbins founded the Anthony Robbins Foundation, intended to help the young, the homeless, the hungry, the elderly, and the imprisoned.`,
    contentStyles: { top: 0, width: "30em" },
    images: [
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-4.jpg").default,
        imageStyles: { width: "32em", height: "18em" },
      },
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-6.jpeg").default,
        imageStyles: { width: "25em", height: "30em" },
      },
    ],
  },
  {
    date: "October 2001",
    content: `In October 2001, Robbins married Bonnie "Sage" Robbins (née Humphrey). They live in Manalapan, Florida.`,
    contentStyles: { top: 0, width: "30em" },
    images: [
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-4.jpg").default,
        imageStyles: { width: "32em", height: "18em" },
      },
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-6.jpeg").default,
        imageStyles: { width: "25em", height: "30em" },
      },
    ],
  },
  {
    date: "2007",
    content: `Robbins has worked on an individual basis with Bill Clinton, Justin Tuck, Wayne Gretzky, Serena Williams, Hugh Jackman, and Pitbull. He has counseled American businessmen Peter Guber, Steve Wynn, and Marc Benioff. He was named one of the "Top 50 Business Intellectuals" by Accenture and one of the "Top 200 Business Gurus" by the Harvard Business Press, and in 2007 was ranked on the Forbes Celebrity 100.`,
    contentStyles: { top: 0, width: "30em" },
    images: [
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-4.jpg").default,
        imageStyles: { width: "32em", height: "18em" },
      },
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-6.jpeg").default,
        imageStyles: { width: "25em", height: "30em" },
      },
    ],
  },
  {
    date: "July 2010",
    content: `In July 2010, NBC debuted "Breakthrough with Tony Robbins", a reality show that followed Robbins as he helped the show's participants face their personal challenges. NBC canceled the show after airing two of the planned six episodes due to low viewership of 2.8 million. In March 2012, the OWN Network picked up the show for another season beginning with the original first season set to re-run and thereafter leading directly into the new 2012 season. In April 2012, Robbins began cohosting Oprah's Lifeclass on the OWN Network.`,
    contentStyles: { top: 0, width: "30em" },
    images: [
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-4.jpg").default,
        imageStyles: { width: "32em", height: "18em" },
      },
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-6.jpeg").default,
        imageStyles: { width: "25em", height: "30em" },
      },
    ],
  },
  {
    date: "2014",
    content: `In 2014, he donated the profits of his book, Money: Master the Game, along with an additional personal donation, through Feeding America to provide meals to people in need. Robbins also donated profits from Unshakeable: Your Financial Freedom Playbook to Feeding America. Robbins works with a water company called Spring Health, which provides fresh water to small villages in rural eastern India to prevent waterborne diseases.`,
    contentStyles: { top: 0, width: "30em" },
    images: [
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-4.jpg").default,
        imageStyles: { width: "32em", height: "18em" },
      },
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-6.jpeg").default,
        imageStyles: { width: "25em", height: "30em" },
      },
    ],
  },
  {
    date: "December 2014",
    content: `In 2015, filmmaker Joe Berlinger directed and produced the documentary Tony Robbins: I Am Not Your Guru, about the Tony Robbins event "Date with Destiny" after filming it in Boca Raton, Florida, in December 2014. It premiered at the South by Southwest film festival in March 2016 and opened the American Documentary Film Festival (AmDocs) in Palm Springs in February 2016. The documentary was translated into languages for 190 countries and released by Netflix on July 15, 2016.`,
    contentStyles: { top: 0, width: "30em" },
    images: [
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-4.jpg").default,
        imageStyles: { width: "32em", height: "18em" },
      },
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-6.jpeg").default,
        imageStyles: { width: "25em", height: "30em" },
      },
    ],
  },
  {
    date: "2014",
    content: `In 2014, he published ‘Money: Master the Game’ which peaked at number one on ‘New York Times’ best-selling list in December. In 2017, he co-authored ‘Unshakeable: Your Financial Freedom Playbook.’`,
    contentStyles: { top: 0, width: "30em" },
    images: [
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-4.jpg").default,
        imageStyles: { width: "32em", height: "18em" },
      },
      {
        alt: "Tony Robbins",
        image: require("../assets/imgs/tony-6.jpeg").default,
        imageStyles: { width: "25em", height: "30em" },
      },
    ],
  },
];

export default contentRows;
